// `/tags?category=<id>` opens the Tags list filtered on one tag category (backend plan
// 2026-10-29-sandbox-default-tag-categories-sync, WP-G: the Developer › Integrations grid links each
// category there). The list keeps the parameter in step with its category filter.
export const CATEGORY_PARAM = 'category';

/** The category id in a location's search string; null when absent or not a positive integer. */
export const categoryFromSearch = (search) => {
    const raw = new URLSearchParams(search || '').get(CATEGORY_PARAM);
    return raw && /^[1-9]\d*$/.test(raw) ? Number(raw) : null;
};

/** `search` with the category set to `id`, or without it when `id` is null; other parameters kept. */
export const searchWithCategory = (search, id) => {
    const params = new URLSearchParams(search || '');
    if (id == null) {
        params.delete(CATEGORY_PARAM);
    } else {
        params.set(CATEGORY_PARAM, String(id));
    }
    const qs = params.toString();
    return qs ? `?${qs}` : '';
};
